export default __webpack_public_path__ + "static/media/problems.a97182f1.png";